module.exports = __webpack_public_path__ + "img/rz.3abe5060.jpg";